export const boxListCountries = {
	display: 'flex',
	alignItems: 'center',
	flexWrap: 'wrap',
	justifyContent: 'center',
	pl: 2,
	pb: 1
}